"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EscapeSequenceEncoder_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscapeSequenceEncoder = void 0;
const inversify_1 = require("inversify");
let EscapeSequenceEncoder = EscapeSequenceEncoder_1 = class EscapeSequenceEncoder {
    constructor() {
        this.stringsCache = new Map();
    }
    encode(string, encodeAllSymbols) {
        const cacheKey = `${string}-${String(encodeAllSymbols)}`;
        if (this.stringsCache.has(cacheKey)) {
            return this.stringsCache.get(cacheKey);
        }
        const result = string.replace(EscapeSequenceEncoder_1.replaceRegExp, (character) => this.encodeCharacter(character, encodeAllSymbols));
        this.stringsCache.set(cacheKey, result);
        this.stringsCache.set(`${result}-${String(encodeAllSymbols)}`, result);
        return result;
    }
    encodeLiteral(value, rawValue, encodeAllSymbols) {
        if (encodeAllSymbols || rawValue === undefined) {
            return this.encode(value, encodeAllSymbols);
        }
        const cacheKey = `literal-${value}-${rawValue}-${String(encodeAllSymbols)}`;
        if (this.stringsCache.has(cacheKey)) {
            return this.stringsCache.get(cacheKey);
        }
        const preservedResult = this.encodePreservingUnicodeEscapes(value, rawValue);
        const result = preservedResult !== null && preservedResult !== void 0 ? preservedResult : this.encode(value, encodeAllSymbols);
        this.stringsCache.set(cacheKey, result);
        return result;
    }
    encodeCharacter(character, encodeAllSymbols) {
        const shouldEncodeCharacter = encodeAllSymbols || EscapeSequenceEncoder_1.forceEscapeCharactersRegExp.test(character);
        if (!shouldEncodeCharacter) {
            return character;
        }
        const radix = 16;
        let prefix;
        let template;
        if (EscapeSequenceEncoder_1.ASCIICharactersRegExp.test(character)) {
            prefix = '\\x';
            template = '00';
        }
        else {
            prefix = '\\u';
            template = '0000';
        }
        return `${prefix}${(template + character.charCodeAt(0).toString(radix)).slice(-template.length)}`;
    }
    encodePreservingUnicodeEscapes(value, rawValue) {
        const rawBody = rawValue.slice(1, -1);
        let result = '';
        let decoded = '';
        let index = 0;
        while (index < rawBody.length) {
            const character = rawBody[index];
            if (character !== '\\') {
                result += this.encodeCharacter(character, false);
                decoded += character;
                index++;
                continue;
            }
            const nextCharacter = rawBody[index + 1];
            if (nextCharacter === undefined) {
                return null;
            }
            if (nextCharacter === 'u' || nextCharacter === 'x') {
                const unicodeEscape = this.readUnicodeEscapeSequence(rawBody, index);
                if (!unicodeEscape) {
                    return null;
                }
                result += unicodeEscape.raw;
                decoded += unicodeEscape.decoded;
                index += unicodeEscape.raw.length;
                continue;
            }
            const simpleEscape = this.readSimpleEscapeSequence(rawBody, index);
            for (const decodedCharacter of simpleEscape.decoded) {
                result += this.encodeCharacter(decodedCharacter, false);
            }
            decoded += simpleEscape.decoded;
            index += simpleEscape.raw.length;
        }
        return decoded === value ? result : null;
    }
    readUnicodeEscapeSequence(rawBody, startIndex) {
        if (rawBody[startIndex + 1] === 'x') {
            return this.readFixedLengthHexEscapeSequence(rawBody, startIndex, 2);
        }
        if (rawBody[startIndex + 2] === '{') {
            return this.readCodePointEscapeSequence(rawBody, startIndex);
        }
        return this.readFixedLengthHexEscapeSequence(rawBody, startIndex, 4);
    }
    readFixedLengthHexEscapeSequence(rawBody, startIndex, hexLength) {
        const hexDigits = rawBody.slice(startIndex + 2, startIndex + 2 + hexLength);
        if (hexDigits.length !== hexLength || !this.isHexString(hexDigits)) {
            return null;
        }
        return {
            raw: rawBody.slice(startIndex, startIndex + 2 + hexLength),
            decoded: String.fromCharCode(parseInt(hexDigits, 16))
        };
    }
    readCodePointEscapeSequence(rawBody, startIndex) {
        const closingBraceIndex = rawBody.indexOf('}', startIndex + 3);
        if (closingBraceIndex === -1) {
            return null;
        }
        const hexDigits = rawBody.slice(startIndex + 3, closingBraceIndex);
        const codePoint = parseInt(hexDigits, 16);
        const maxCodePoint = 1114111;
        if (!hexDigits.length || !this.isHexString(hexDigits) || codePoint > maxCodePoint) {
            return null;
        }
        return {
            raw: rawBody.slice(startIndex, closingBraceIndex + 1),
            decoded: String.fromCodePoint(codePoint)
        };
    }
    readSimpleEscapeSequence(rawBody, startIndex) {
        var _a;
        const escapeCharacter = rawBody[startIndex + 1];
        switch (escapeCharacter) {
            case 'n':
                return { raw: '\\n', decoded: '\n' };
            case 'r':
                return { raw: '\\r', decoded: '\r' };
            case 't':
                return { raw: '\\t', decoded: '\t' };
            case 'b':
                return { raw: '\\b', decoded: '\b' };
            case 'f':
                return { raw: '\\f', decoded: '\f' };
            case 'v':
                return { raw: '\\v', decoded: '\v' };
            case '\r': {
                const isCarriageReturnLineFeed = rawBody[startIndex + 2] === '\n';
                return { raw: isCarriageReturnLineFeed ? '\\\r\n' : '\\\r', decoded: '' };
            }
            case '\n':
                return { raw: '\\\n', decoded: '' };
            default:
                break;
        }
        if (EscapeSequenceEncoder_1.octalDigitRegExp.test(escapeCharacter)) {
            let octalDigits = escapeCharacter;
            const maxOctalLength = escapeCharacter <= '3' ? 3 : 2;
            while (octalDigits.length < maxOctalLength &&
                EscapeSequenceEncoder_1.octalDigitRegExp.test((_a = rawBody[startIndex + 1 + octalDigits.length]) !== null && _a !== void 0 ? _a : '')) {
                octalDigits += rawBody[startIndex + 1 + octalDigits.length];
            }
            return {
                raw: `\\${octalDigits}`,
                decoded: String.fromCharCode(parseInt(octalDigits, 8))
            };
        }
        return { raw: `\\${escapeCharacter}`, decoded: escapeCharacter };
    }
    isHexString(string) {
        for (const character of string) {
            if (!EscapeSequenceEncoder_1.hexDigitRegExp.test(character)) {
                return false;
            }
        }
        return true;
    }
};
exports.EscapeSequenceEncoder = EscapeSequenceEncoder;
EscapeSequenceEncoder.ASCIICharactersRegExp = /[\x00-\x7F]/;
EscapeSequenceEncoder.forceEscapeCharactersRegExp = /[\x00-\x1F\x7F-\x9F'"\\\s]/;
EscapeSequenceEncoder.replaceRegExp = /[\s\S]/g;
EscapeSequenceEncoder.hexDigitRegExp = /[0-9a-fA-F]/;
EscapeSequenceEncoder.octalDigitRegExp = /[0-7]/;
exports.EscapeSequenceEncoder = EscapeSequenceEncoder = EscapeSequenceEncoder_1 = __decorate([
    (0, inversify_1.injectable)()
], EscapeSequenceEncoder);
